"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CloserCoupon_1 = require("./CloserCoupon");
exports.default = CloserCoupon_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/shared/CloserCoupon/index.js
// module id = 762
// module chunks = 8